module.exports = __webpack_public_path__ + "img/151.482c0138.jpg";